import styled from 'styled-components'
import { StyledButtonBase } from 'components/Button/Button.styles'
import { Color } from 'root-constants'

export const StyledDownload = {
  Wrapper: styled.div`
    position: relative;
    max-width: 360px;
    margin: 0 auto;
    padding: 0 15px;
    z-index: 2;
  `,
  Title: styled.p`
    margin: 40px 0;
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    color: ${Color.WHITE};
  `,
  Subtitle: styled.p`
    margin: 16px 0 77px;
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
  `,
  Image: styled.img`
    margin: 16px auto 0;
  `,
  Button: styled.button`
    ${StyledButtonBase};
    position: sticky;
    position: -webkit-sticky;
    max-width: 328px;
    bottom: 15px;
    margin-top: 16px;
    font-size: 20px;
    font-weight: 700;
    line-height: 54px;
  `,
}
